import React, { useEffect, useState } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Card, CardBody, Container, FormGroup, Input, Label, Badge, Button, CardHeader } from 'reactstrap';
import { IoIosClose } from "react-icons/io";
import _ from 'lodash';

import LoadingOverlay from 'components/Indicator/LoadingOverlay';
import AlertNotSubscribe from 'components/Alert'
import PageTitle from 'components/Title/PageTitle';
import Lang from 'Lang/General';
import CKEditor5 from 'components/RTE/index'
import WithHOC from './action';

function Setting(props) {
  const [tempEmail, setTempEmail] = useState('')
  const [allEmails, setAllEmails] = useState([])

  useEffect(() => {
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Customer Dialogue System' })
    props.onChangeSettingHOC('subscribedPackage', tmpIndex > -1)

    props.getSelectedSetting()
  }, [])

  useEffect(() => {
    setAllEmails(props.selectedSetting.emails)
  }, [props.selectedSetting])

  const onDeleteField = (index) => {
    let temp = _.cloneDeep(allEmails)

    temp.splice(index, 1)

    if (!props.selectedSetting.id) {
      props.createSetting({
        ...props.selectedSetting,
        emails: temp
      })
    } else {
      props.updateSetting({
        ...props.selectedSetting,
        emails: temp
      })
    }

    setAllEmails(temp)
  }

  return (
    <>
      <PageTitle
        heading={Lang['SUPPORT_EMAIL'][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-mail icon-gradient bg-happy-itmeo"
        buttons={[]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          {!props.subscribedPackage && <AlertNotSubscribe {...props} />}
          <Card>
            <CardHeader>
              {Lang['SUPPORT_EMAIL_SETTINGS'][props.data.languageReducer.userSettings.admin_panel_language]}
            </CardHeader>
            <CardBody>
              <FormGroup>
                <Label>
                  {Lang['SUBJECT'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  value={props.selectedSetting.subject}
                  onChange={e => {
                    props.onChangeSettingHOC('selectedSetting', {
                      ...props.selectedSetting,
                      subject: e.target.value
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <Label>
                  {Lang['CONTENT'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <CKEditor5
                  selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
                  data={props.selectedSetting.content}
                  height={'100px'}
                  onChange={(event, editor) => {
                    props.onChangeSettingHOC('selectedSetting', {
                      ...props.selectedSetting,
                      content: editor.getData()
                    })
                  }}
                />
              </FormGroup>
              <div className="d-flex">
                <Button
                  className="ml-auto"
                  disabled={!props.subscribedPackage}
                  onClick={() => {
                    if (!props.selectedSetting.id) {
                      return props.createSetting({
                        ...props.selectedSetting,
                        emails: allEmails
                      })
                    }

                    return props.updateSetting({
                      ...props.selectedSetting,
                      emails: allEmails
                    })
                  }}
                >
                  {Lang['SUBMIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Button>
              </div>
            </CardBody>
          </Card>
          <Card className="mt-3">
            <CardHeader>
              {Lang['PENDING_UNANSWERED_DIALOGUE_EMAIL_SETTINGS'][props.data.languageReducer.userSettings.admin_panel_language]}
            </CardHeader>
            <CardBody>
              <FormGroup>
                <Label>
                  {Lang['MINUTES_UNTIL_NOTIFICATION_NO_CS_REPLY'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  type="number"
                  min="0"
                  value={props.selectedSetting.customer_support_reminder_duration || 0}
                  onChange={e => {
                    props.onChangeSettingHOC('selectedSetting', {
                      ...props.selectedSetting,
                      customer_support_reminder_duration: Number(e.target.value.replace(/[^0-9]/g, ''))
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <Label>
                  {Lang['SUBJECT'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  value={props.selectedSetting.customer_support_reminder_subject}
                  onChange={e => {
                    props.onChangeSettingHOC('selectedSetting', {
                      ...props.selectedSetting,
                      customer_support_reminder_subject: e.target.value
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <Label>
                  {Lang['CONTENT'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <CKEditor5
                  selectedLanguage={props.data.languageReducer.userSettings.admin_panel_language}
                  data={props.selectedSetting.customer_support_reminder_content}
                  height={'100px'}
                  onChange={(event, editor) => {
                    props.onChangeSettingHOC('selectedSetting', {
                      ...props.selectedSetting,
                      customer_support_reminder_content: editor.getData()
                    })
                  }}
                />
                {/* <small className="form-text text-muted">
                  {Lang['COCKPIT_LINK_VARIABLE_HINT'][props.data.languageReducer.userSettings.admin_panel_language]}
                </small> */}
              </FormGroup>
              <div className="d-flex">
                <Button
                  className="ml-auto"
                  disabled={!props.subscribedPackage}
                  onClick={() => {
                    if (!props.selectedSetting.id) {
                      return props.createSetting({
                        ...props.selectedSetting,
                        emails: allEmails
                      })
                    }

                    return props.updateSetting({
                      ...props.selectedSetting,
                      emails: allEmails
                    })
                  }}
                >
                  {Lang['SUBMIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Button>
              </div>
            </CardBody>
          </Card>
          <Card className="mt-3">
            <CardHeader>
              {Lang['ADD_EMAIL'][props.data.languageReducer.userSettings.admin_panel_language]}
            </CardHeader>
            <CardBody>
              <FormGroup>
                <Label>
                  {Lang['ADD_EMAIL_ADDRESS'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <div className="d-flex" style={{ gap: 7 }}>
                  <Input
                    value={tempEmail}
                    onChange={e => setTempEmail(e.target.value)}
                  />
                  <Button
                    className={'ml-auto'}
                    color={'primary'}
                    disabled={!tempEmail || !props.subscribedPackage}
                    style={{ textTransform: 'capitalize' }}
                    onClick={() => {
                      setTempEmail('')
                      if (!props.selectedSetting.id) {
                        props.createSetting({
                          ...props.selectedSetting,
                          emails: [
                            ...allEmails,
                            tempEmail
                          ]
                        })
                      } else {
                        props.updateSetting({
                          ...props.selectedSetting,
                          emails: [
                            ...allEmails,
                            tempEmail
                          ]
                        })
                      }

                      return setAllEmails([
                        ...allEmails,
                        tempEmail
                      ])
                    }}
                  >
                    {Lang['ADD'][props.data.languageReducer.userSettings.admin_panel_language]}
                  </Button>
                </div>
              </FormGroup>
              <div className="d-flex flex-wrap" style={{ gap: 7 }}>
                {
                  allEmails.map((emailChild, emailIndex) => (
                    <Badge className="d-flex align-items-center p-2" style={{ textTransform: 'unset' }}>
                      {emailChild}
                      <IoIosClose
                        style={{
                          marginLeft: 7,
                          cursor: 'pointer'
                        }}
                        fontSize={15}
                        disabled={!props.subscribedPackage}
                        onClick={() => onDeleteField(emailIndex)}
                      />
                    </Badge>
                  ))
                }
              </div>
            </CardBody>
          </Card>
        </Container>
      </ReactCSSTransitionGroup>
      {
        props.onLoadSettingHOC && <LoadingOverlay />
      }
    </>
  );
}

export default WithHOC(Setting)